
import { Component, Vue, Prop } from 'vue-property-decorator';
import stores from '@/stores';
import { SweetModal } from 'sweet-modal-vue';
import router from '@/router';
import {showToaster} from "@/components/DashboardComposer/helpers";
import {translate} from "@/helpers/functions";

@Component({
 components: {
   SweetModal,
 },
})

export default class CreateCategory extends Vue {
  @Prop()
  module!: IModule;

  newItem = {
    id: null,
    active: true,
    name: '',
    imageId: null,
    moduleId: null,
    sort: null,
  };

  nameRules = {
    required: true
  };
  errors: string[] = [];

  submitNewItem() {
    if (this.newItem) {
      this.errors = [];
      return this.module.createNewItem!((this.newItem))
        .then((response) => {
          if (!response.success) {
            throw new Error(response.error.message);
          }
          showToaster('success', this.newItem.name, translate('successfully-created'));
          if (`${this.module.path}.items.show` === 'catalogue.items.show' || `${this.module.path}.items.show` === 'service.items.show') {
            this.$router.push({name: `${this.module.path}.items.show`, params: {id: response.data.id}});
            router.go(0);
          } else {
            this.$router.push({name: `${this.module.path}.items.show`, params: {id: response.data.id}});
          }
          this.cancel();
        })
        .catch((e) => {
          this.errors.push(e.message);
          console.log(e);
        });
    }
  }
  cancel() {
    (document.getElementById('create-form') as HTMLFormElement).classList.remove('was-validated');
    this.errors = [];
    // @ts-ignore
    this.$children[0].close();
  }

  mounted() {

    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    const form = document.getElementById('create-form') as HTMLFormElement;
    form.addEventListener('submit', (event: any) => {
      event.preventDefault();
      if (form.checkValidity() === true) {
        event.stopPropagation();
        this.submitNewItem();
      }
      if (form.checkValidity() === false) {
        event.stopPropagation();
      }
      form.classList.add('was-validated');
    }, false);
  }
}
